import { useGeolocated } from "react-geolocated";
export default function TestTips2() {
  const {
    coords: { latitude, longitude } = {},
    isGeolocationAvailable,
    isGeolocationEnabled,
    positionError,
  } = useGeolocated({
    positionOptions: { enableHighAccuracy: false },
    userDecisionTimeout: 1000 * 60 * 10, // 10分钟超时
  });

  if (!isGeolocationAvailable) return <div className="color-#fff py-20 pl-20 text-16">浏览器不支持定位</div>;
  if (!isGeolocationEnabled) return <div className="color-#fff py-20 pl-20 text-16">定位未开启</div>;
  if (positionError) return <div className="color-#fff py-20 pl-20 text-16">错误：{positionError.message}</div>;

  return (
    <div className="color-#fff py-20 pl-20 text-16">
      纬度：{latitude} <br />
      经度：{longitude}
    </div>
  );
}
